import { T, Ico } from '../../../design';

export interface ContextBannerProps {
  salonName: string;
  employeeName: string;
  onChange: () => void;
}

export function ContextBanner({ salonName, employeeName, onChange }: ContextBannerProps) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 14px', background: T.dark, color: T.onAccent }}>
      <span style={{ width: 30, height: 30, borderRadius: 9, background: T.accentLight, color: T.accent, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}><Ico.bolt size={16} /></span>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', color: T.onDarkMuted }}>Admin-mode · du agerer som</div>
        <div style={{ fontSize: 13, fontWeight: 800, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{salonName} · {employeeName}</div>
      </div>
      <button onClick={onChange} aria-label="Skift salon og medarbejder" style={{ border: 0, background: T.accentLight, color: T.accent, fontSize: 11.5, fontWeight: 700, padding: '7px 11px', borderRadius: 9, cursor: 'pointer', flexShrink: 0, fontFamily: T.font }}>Skift</button>
    </div>
  );
}
